<script setup lang="ts">
import { RouterView } from 'vue-router'

import AppToastContainer from '@/components/ui/AppToastContainer.vue'

import { useIdleSessionMonitor } from '@/composables/useIdleSessionMonitor'

// Monitor user session and auto-logout on expiration
// - Checks session after 15 minutes of inactivity
// - Session lifetime: 120 minutes (matches Laravel SESSION_LIFETIME)
// - Periodic checks every 10 minutes
useIdleSessionMonitor({
  idleTimeoutMinutes: 15,
  sessionLifetimeMinutes: 120,
  periodicCheckIntervalMinutes: 10,
  debug: false,
})
</script>

<template>
  <div id="app">
    <RouterView v-slot="{ Component, route }">
      <Transition name="page" mode="in-out">
        <component :is="Component" :key="route.path" />
      </Transition>
    </RouterView>
    <AppToastContainer />
  </div>
</template>

<style scoped>
#app {
  @apply min-h-screen;
}

.page-enter-active,
.page-leave-active {
  transition: opacity 0.1s ease;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
}
</style>
